import { faArrowRight } from '@fortawesome/pro-regular-svg-icons'
import Button from 'components/Button'
import MFDAnnouncementBanner from 'components/Collectives/Common/MFDAnnouncementBanner'
import ModalTrigger from 'components/common/ModalTrigger'
import GenericLayout from 'components/GenericLayout'
import VideoEmbedModal from 'components/VideoEmbedModal/VideoEmbedModal'
import moment from 'moment'
import Image from 'next/image'
import Link from 'next/link'
import React from 'react'

function AboutPage() {
  return (
    <>
      <MFDAnnouncementBanner />

      <GenericLayout bgColor="bg-white">
        <div className="relative pb-20 overflow-hidden">
          <div className="relative">
            <div className="flex flex-col justify-between grid-flow-col lg:mx-auto lg:max-w-8xl lg:grid lg:grid-cols-2 lg:grid-flow-col-dense lg:gap-24">
              <div className="px-4 max-w-xl mx-auto sm:px-6 lg:max-w-none lg:mx-0 lg:px-0">
                <div>
                  <div className="mt-6 lg:mt-0">
                    <h2 className="text-3xl font-bold tracking-tight text-gray-800">
                      {`Upstream is the easiest way to start a DAO`}
                    </h2>
                  </div>
                  <div className="my-8">
                    <h5 className="text-xl tracking-tight text-gray-800 font-light">
                      {`The simplest no-code solution for DAOs`}
                    </h5>
                  </div>

                  <div className="border-b border-gray-200 w-full" />

                  <div
                    className="mt-6 text-lg text-gray-500 space-y-6"
                    style={{ fontFamily: 'Nunito' }}
                  >
                    <p>
                      A DAO (decentralized autonomous organization) is an
                      internet community built on the blockchain that organizes
                      around a shared mission they want to accomplish.
                    </p>
                    <p>
                      Upstream’s no-code DAO builder makes it simple to launch
                      and manage a DAO without needing any technical experience.
                      Think Wix or Squarespace for DAOs.{' '}
                    </p>
                    <p>
                      The complicated tech stack for DAOs is streamlined into
                      one platform with your governance, treasury, token gating,
                      voting, and chat all in one place.
                    </p>
                    <p>
                      With Upstream, you can focus on what matters for your
                      community without wasting time switching between platforms
                      and trying to build things yourself.
                    </p>
                    <p>
                      Used by blue chip NFT projects, sophisticated investment
                      clubs, and social clubs alike, Upstream DAOs is beloved by
                      web3 communities big and small.
                    </p>
                    <p>
                      Read more about Upstream in{' '}
                      <a
                        href="https://www.forbes.com/sites/alexkonrad/2022/03/09/web3-upstream-raises-12-million-dao-tools/?sh=2bae1dfa3cfb"
                        target="_blank"
                        rel="noreferrer"
                        className="text-blue"
                      >
                        Forbes
                      </a>
                      {', '}
                      <a
                        href="https://techcrunch.com/2022/08/03/upstreams-new-vault-could-help-nft-holders-sleep-at-night/"
                        target="_blank"
                        rel="noreferrer"
                        className="text-blue"
                      >
                        TechCrunch
                      </a>
                      {', '}
                      <a
                        href="https://fortune.com/2022/08/03/vault-dao-crypto-nfts-alex-taub-upstream/"
                        target="_blank"
                        rel="noreferrer"
                        className="text-blue"
                      >
                        Fortune
                      </a>
                      {', '}
                      <a
                        href="https://hbr.org/2022/05/what-a-dao-can-and-cant-do"
                        target="_blank"
                        rel="noreferrer"
                        className="text-blue"
                      >
                        HBR
                      </a>
                      {', '}
                      <a
                        href="https://www.protocol.com/fintech/investment-daos"
                        target="_blank"
                        rel="noreferrer"
                        className="text-blue"
                      >
                        Protocol
                      </a>
                      {', '}
                      <a
                        href="https://www.theblockcrypto.com/post/124685/social-platform-upstream-is-building-a-dao-it-yourself-kit"
                        target="_blank"
                        rel="noreferrer"
                        className="text-blue"
                      >
                        The Block
                      </a>
                      {', '}
                      <a
                        href="https://www.coindesk.com/business/2022/03/09/dao-creation-platform-upstream-raises-125m-and-launches-publicly/"
                        target="_blank"
                        rel="noreferrer"
                        className="text-blue"
                      >
                        CoinDesk
                      </a>
                      , and more!
                    </p>

                    <div className="flex flex-col md:flex-row space-x-4 items-center border-t border-b border-gray-100 py-5">
                      <p className="text-center md:text-right text-gray-400">
                        Want to learn more? Check out a video walkthrough of a
                        DAO on Upstream here:
                      </p>

                      <ModalTrigger
                        trigger={onClick => (
                          <div
                            className={`border border-gray-200 rounded-lg p-2 cursor-pointer shrink-0`}
                            onClick={onClick}
                          >
                            <div className="relative overflow-hidden rounded-lg group bg-red-500 w-[264px] h-[134px]">
                              <Image
                                alt="Upstream demo video"
                                src="https://img.youtube.com/vi/h0GQ8anXUb4/mqdefault.jpg"
                                fill
                                sizes="25vw"
                              />
                              <div
                                className="bg-no-repeat bg-center bg-[length:92px_92px] absolute inset-0 opacity-80 group-hover:opacity-100"
                                style={{
                                  backgroundImage:
                                    'url(/static/events/play_button.png)'
                                }}
                              />
                            </div>
                          </div>
                        )}
                      >
                        <VideoEmbedModal
                          title={`Upstream Tutorial`}
                          postedTimestamp={moment('2022-04-06').toDate()}
                          url={`https://www.youtube.com/embed/h0GQ8anXUb4`}
                        />
                      </ModalTrigger>
                    </div>

                    <p>
                      {'Have questions? Email us at '}
                      <a
                        href="mailto:help@upstreamapp.com."
                        className="text-blue"
                      >
                        help@upstreamapp.com
                      </a>
                      .
                    </p>
                  </div>
                  <Link href="/discover" passHref>
                    <Button
                      size="lg"
                      color="transparent"
                      label="Get started"
                      labelClassName="font-medium"
                      className="transition-all px-10 py-3 w-60 mt-4 border-2"
                      icon={faArrowRight}
                      iconPlacement="after"
                    />
                  </Link>
                </div>
              </div>

              <div className="order-first lg:order-last mt-12 sm:mt-16 lg:mt-0 md:h-96 sm:h-60 lg:h-96 h-96 relative">
                <Image
                  alt="Community and DAO"
                  src="/static/about/about.svg"
                  fill
                  sizes="25vw"
                />
              </div>
            </div>
          </div>
        </div>
      </GenericLayout>
    </>
  )
}

export default AboutPage
